import React, { useMemo } from 'react';
import { panelsAtom } from '@src/atoms/panels';
import { useAtomValue } from 'jotai';

import Empty from '@images/layout/empty.svg';
import { Focus, ZenWrapper } from './styled';
import { useSelector } from 'react-redux';
import { widgetPanelFeatureSelector } from '@src/store/common/selectors';

function ZenPanel() {
  const panels = useAtomValue(panelsAtom);
  const widgetPanelEnabled = useSelector(widgetPanelFeatureSelector);

  const zenMode = useMemo(() => {
    const filteredPanels: any = { ...panels };
    if (widgetPanelEnabled) {
      delete filteredPanels.summary;
    }
    return Object.values(filteredPanels).every((x) => !x);
  }, [panels, widgetPanelEnabled]);

  return zenMode ? (
    <ZenWrapper>
      <Focus>
        <Empty />
      </Focus>
    </ZenWrapper>
  ) : null;
}

export default ZenPanel;
